var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 1.25H3.125C2.43125 1.25 1.875 1.8125 1.875 2.5V11.25C1.875 11.9375 2.43125 12.5 3.125 12.5H5.625L7.5 14.375L9.375 12.5H11.875C12.5625 12.5 13.125 11.9375 13.125 11.25V2.5C13.125 1.8125 12.5625 1.25 11.875 1.25ZM8.125 11.25H6.875V10H8.125V11.25ZM9.41875 6.40625L8.85625 6.98125C8.40625 7.4375 8.125 7.8125 8.125 8.75H6.875V8.4375C6.875 7.75 7.15625 7.125 7.60625 6.66875L8.38125 5.88125C8.6125 5.65625 8.75 5.34375 8.75 5C8.75 4.3125 8.1875 3.75 7.5 3.75C6.8125 3.75 6.25 4.3125 6.25 5H5C5 3.61875 6.11875 2.5 7.5 2.5C8.88125 2.5 10 3.61875 10 5C10 5.55 9.775 6.05 9.41875 6.40625Z",
    fill: "#FF6700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveHelp);
export default __webpack_public_path__ + "static/media/live_help.9b173e277f8178e165d1d39b399e070c.svg";
export { ForwardRef as ReactComponent };